











import {Vue, Component, Prop} from 'vue-property-decorator';
import {VacationDto} from "@/dto/payroll/VacationDTO";
import moment, {Moment} from "moment-timezone";
import {prettyEnum} from "@/utils/StringUtils";
import Application from "@/state/Application";
import PayrollService from "@/services/payroll/PayrollService";
import {processError} from "@/utils/ComponentUtils";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import VacationService from "@/services/payroll/VacationService";
import {SickLeave} from "@/components/payroll/sickLeave/SickLeave";
import SickLeaveService from "@/services/payroll/SickLeaveService";

@Component({
	methods: {
		moment(inp?: moment.MomentInput, format?: moment.MomentFormatSpecification, language?: string, strict?: boolean): Moment {
			return moment(inp, format, language, strict)
		},
		prettyEnum
	}
})
export default class SickLeaveOptionsModal extends Vue {

	@Prop()
	private sickLeave!: SickLeave

	@Prop()
	private callback!: () => void

	private delete() {
		Application.startLoading()
		SickLeaveService.deleteSickLeaveRecord(this.sickLeave.id!, this.sickLeave.employment.id!).then(
			() => {
				this.$modal.hideAll()
				Application.stopLoading()
				this.callback()
			},
			err => processError(err, this)
		)
	}

	private deleteVacation() {
		this.$modal.show(
			DeleteConfirmation,
			{
				onDelete: () => this.delete(),
				targetName: "sick leave"
			}
		)
	}


}

